import React, { Component } from "react";

import { Row, Select, Spin } from "antd";

import { SearchOutlined } from "@ant-design/icons";
import { ReactTinyLink } from "react-tiny-link";

import "./landingPageDesign.css";
const { Option } = Select;

export default class LandingPageSearch extends Component {
  lastFetchId = 0;

  state = {
    data: [],
    valueSearchNews: [],
    fetching: false,
  };

  //https://newsapi.org/v2/sources?apiKey=b83273bdba8945fb90f924537a93884a
  fetchNewsSearch = (value) => {
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true });
    fetch(
      "https://newsapi.org/v2/top-headlines?category=health&q=" +
      value +
      "&apiKey=b83273bdba8945fb90f924537a93884a"
    )
      .then((response) => response.json())
      .then((body) => {
        if (fetchId !== this.lastFetchId) {
          // for fetch callback order
          return;
        }
        console.log(
          value,
          "====",
          "https://newsapi.org/v2/top-headlines?category=health&q=" +
          value +
          "&apiKey=b83273bdba8945fb90f924537a93884a"
        );
        const data = body.articles.map((news) => ({
          id: news.source.id,
          name: news.source.name,
          url: news.url,
          description: news.description,
        }));
        this.setState({ data, fetching: false });
      });
  };

  handleChangeSearch = (valueSearchNews) => {
    this.setState({
      valueSearchNews,
      data: [],
      fetching: false,
    });
  };

  render() {
    const { fetching, data, valueSearchNews } = this.state;

    return (
      <Row style={{ height: "100%" }}>
        <Select
          showSearch
          value={valueSearchNews}
          placeholder={
            <span style={{ color: "#fff !important" }}>
              <SearchOutlined /> Search
            </span>
          }
          notFoundContent={fetching ? <Spin size="small" /> : null}
          defaultActiveFirstOption={false}
          showArrow={false}
          filterOption={false}
          onSearch={this.fetchNewsSearch}
          onChange={this.handleChangeSearch}
          style={{
            width: "100%",
            backgroundColor: "transparent",
            height: "100%",
          }}
          dropdownClassName="dropdownClassNameSearchNews"
          listHeight={600}
        >
          {data.map((d, index) => (
            <Option
              key={d.id + "Web" + index}
              value={d.name}
              style={{ borderBottom: "1px solid #ccc", paddingBottom: 10 }}
            >
              <a href={d.url} tarGet="_blank" title={d.description}>
                <p style={{ padding: 0, margin: 0 }}>{d.name}</p>
              </a>
              <ReactTinyLink
                cardSize="small"
                showGraphic={true}
                maxLine={2}
                minLine={1}
                url={d.url}
                width="100%"
              />
            </Option>
          ))}
        </Select>
      </Row>
    );
  }
}
